export default __webpack_public_path__ + "static/media/ant3.b15fafee.jpg";